<svelte:options customElement="hb-layout-desktop" />

<script lang="ts">
  /**
   * Svelte Video Gallery WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import pkg from "../../../package.json";

  import type { Events as OffcanvasEvents } from "../offcanvas/types/webcomponent.type";
  import type { Events as NavbarEvents } from "../navbar/types/webcomponent.type";
  import type { Events as FooterEvents } from "../footer/types/webcomponent.type";
  import type { Events as SidebarDesktopEvents } from "../sidebar-desktop/types/webcomponent.type";

  import type { Component } from "./types/webcomponent.type";
  import { addComponent, LanguageTranslator } from "wc-js-utils";

  let {
    id = "",
    // style = "",
    footer = { type: "auto", disable_expanding_small: false },
    cookielawuri4more = "",
    cookielawallowdecline = undefined,
    cookielawlanguage = "",
    pagename = undefined,
    cookielaw = undefined,
    single_screen = undefined,
    sidebar = undefined,
    socials = undefined,
    navlinks = undefined,
    contacts = undefined,
    columns = undefined,
    usermenu = undefined,
    i18nlang = undefined,
    i18nlanguages = undefined,
    page_title = undefined,
    policies = undefined,
    company = undefined,
  }: Component = $props();

  // let translator: LanguageTranslator;
  let navopen: boolean = $state(true);

  $effect(() => {
    if (navopen !== true && navopen !== false) navopen = true;
    if (typeof footer === "string") footer = JSON.parse(footer);
    if (!footer.type) footer.type = "auto";

    if (typeof single_screen === "string") {
      if (single_screen !== "no") single_screen = true;
      else single_screen = false;
    } else if (!single_screen) {
      single_screen = false;
    }

    if (!sidebar) sidebar = {};
    else if (typeof sidebar === "string") {
      sidebar = JSON.parse(sidebar);
    }
    if (!company) {
      company = undefined;
    } else if (typeof company === "string") {
      company = JSON.parse(company as unknown as string);
    }
  });

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  addComponent({ repoName: "@htmlbricks/hb-footer", version: pkg.version });
  addComponent({ repoName: "@htmlbricks/hb-offcanvas", version: pkg.version });
  addComponent({ repoName: "@htmlbricks/hb-navbar", version: pkg.version });
  addComponent({
    repoName: "@htmlbricks/hb-cookie-law-banner",
    version: pkg.version,
  });
  addComponent({
    repoName: "@htmlbricks/hb-sidebar-desktop",
    version: pkg.version,
  });
  // addComponent({ repoName: "@htmlbricks/hb-sidebar-desktop", version: pkg.version });

  function openmenu(o: OffcanvasEvents["offcanvasswitch"]) {
    console.log("burgerclick", o);
    navopen = o.isOpen;
    // handleResize();

    dispatch("offcanvasswitch", o);
  }
  // function detectSize() {
  // 	console.log("resize");
  // 	const c = $host()?.shadowRoot?.querySelector("#container");
  // 	const s = $host()?.shadowRoot?.querySelector("#sidebarcontainer");
  // 	const pageHeight = c.offsetHeight;
  // 	const intFrameHeight = window.innerHeight; // or

  // 	s.style.height = pageHeight + "px";
  // 	s.style.minHeight = intFrameHeight - 50 + "px";
  // }

  // onMount(() => {
  // 	handleResize();
  // });
</script>

{#if navlinks?.length && navopen === true}
  <div id="desktop">
    <hb-navbar
      id="navbar"
      part="navbar"
      noburger={navlinks?.length ? "" : "no"}
      companybrandname={page_title || company?.siteName || ""}
      usermenu={usermenu || ""}
      switchopen={navopen ? "yes" : "no"}
      onnavmenuswitch={(el: { detail: NavbarEvents["navmenuswitch"] }) =>
        openmenu(el.detail)}
      onnavbarDropDownClick={(el: {
        detail: NavbarEvents["navbarDropDownClick"];
      }) => dispatch("navbarDropDownClick", el.detail)}
      onnavbarSlotClick={(l: { detail: NavbarEvents["navbarSlotClick"] }) =>
        dispatch("navbarSlotClick", l.detail)}
    >
      <span slot="left-slot">
        <!-- <span
			onclick={() => {
				navopen = !navopen;
			}}>burger</span
		> -->
        {#if company?.logoUri}
          <img
            class="hb-layout-desktop__brand-logo"
            alt=""
            src={company.logoUri}
          />
        {/if}
        {#if sidebar?.title}
          {sidebar.title}
        {/if}
      </span>

      <span slot="center-slot"><slot name="nav-center-slot" /></span>
      <span slot="right-slot"><slot name="nav-right-slot" /></span>
    </hb-navbar>

    <div
      class="columns is-gapless is-mobile mb-0 mt-0 hb-layout-desktop__columns"
    >
      <aside class="column is-narrow p-0 hb-layout-desktop__sidebar">
        <div class="hb-layout-desktop__sidebar-inner">
          <hb-sidebar-desktop
            id="sidebarcontainer"
            onpageChange={(e: { detail: SidebarDesktopEvents["pageChange"] }) =>
              dispatch("pageChange", e.detail)}
            onthemeChange={(e: {
              detail: SidebarDesktopEvents["themeChange"];
            }) => dispatch("themeChange", e.detail)}
            onlanguageChange={(e: {
              detail: SidebarDesktopEvents["languageChange"];
            }) => dispatch("languageChange", e.detail)}
            navlinks={navlinks || "[]"}
            navpage={pagename || ""}
            i18nlang={i18nlang || ""}
            {i18nlanguages}
            enablefooter={sidebar?.enablefooter || "yes"}
            enablethemeswitch={sidebar?.enablethemeswitch || "yes"}
          ></hb-sidebar-desktop>
        </div>
      </aside>
      <div
        class="column p-0 hb-layout-desktop__content"
        class:hb-layout-desktop__content--single-screen={single_screen}
        part="container"
      >
        {#if single_screen}
          <div class="hb-layout-desktop__page" part="page" id="page">
            <slot name="page">page</slot>
          </div>
          {#if cookielaw === "yes" || cookielaw === "true" || cookielawallowdecline === "yes" || cookielawallowdecline === "no" || cookielawlanguage?.length || cookielawuri4more?.length}
            <hb-cookie-law-banner
              language={cookielawlanguage || i18nlang}
              allowdecline={cookielawallowdecline}
              {cookielawuri4more}
            ></hb-cookie-law-banner>
          {/if}
          <hb-footer
            {policies}
            type={footer.type === "auto" ? "small" : footer.type}
            disable_expanding_small={footer.disable_expanding_small
              ? "yes"
              : "no"}
            part="footer"
            socials={socials ? JSON.stringify(socials) : ""}
            contacts={contacts ? JSON.stringify(contacts) : ""}
            style="display:block;"
            company={company ? JSON.stringify(company) : ""}
            columns={columns || ""}
            onfooterClick={(el: { detail: FooterEvents["footerClick"] }) =>
              dispatch("footerClick", el.detail)}
          ></hb-footer>
        {:else}
          <div
            class="hb-layout-desktop__page hb-layout-desktop__page--footer-inside"
            part="page"
            id="page"
          >
            <div class="hb-layout-desktop__page-stretch">
              <div class="hb-layout-desktop__page-slot">
                <slot name="page">page</slot>
              </div>
              {#if cookielaw === "yes" || cookielaw === "true" || cookielawallowdecline === "yes" || cookielawallowdecline === "no" || cookielawlanguage?.length || cookielawuri4more?.length}
                <hb-cookie-law-banner
                  language={cookielawlanguage || i18nlang}
                  allowdecline={cookielawallowdecline}
                  {cookielawuri4more}
                ></hb-cookie-law-banner>
              {/if}
              <hb-footer
                {policies}
                type={footer.type === "auto" ? "regular" : footer.type}
                disable_expanding_small={footer.disable_expanding_small
                  ? "yes"
                  : "no"}
                part="footer"
                socials={socials ? JSON.stringify(socials) : ""}
                contacts={contacts ? JSON.stringify(contacts) : ""}
                style="display:block;"
                company={company ? JSON.stringify(company) : ""}
                columns={columns || ""}
                onfooterClick={(el: { detail: FooterEvents["footerClick"] }) =>
                  dispatch("footerClick", el.detail)}
              ></hb-footer>
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
{:else}
  <div id="desktop_without_sidebar">
    <hb-navbar
      id="navbar"
      part="navbar"
      noburger={navlinks?.length ? "" : "no"}
      companybrandname={page_title || company?.siteName || ""}
      usermenu={usermenu || ""}
      switchopen={navopen ? "yes" : "no"}
      onnavmenuswitch={(el: { detail: NavbarEvents["navmenuswitch"] }) =>
        openmenu(el.detail)}
      onnavbarDropDownClick={(el: {
        detail: NavbarEvents["navbarDropDownClick"];
      }) => dispatch("navbarDropDownClick", el.detail)}
      onnavbarSlotClick={(l: { detail: NavbarEvents["navbarSlotClick"] }) =>
        dispatch("navbarSlotClick", l.detail)}
    >
      <span slot="left-slot">
        <!-- <span
			onclick={() => {
				navopen = !navopen;
			}}>burger</span
		> -->
        {#if company?.logoUri}
          <img
            class="hb-layout-desktop__brand-logo"
            alt=""
            src={company.logoUri}
          />
        {/if}
        {#if sidebar?.title}
          {sidebar.title}
        {/if}
      </span>

      <span slot="center-slot"><slot name="nav-center-slot" /></span>
      <span slot="right-slot"><slot name="nav-right-slot" /></span>
    </hb-navbar>
    <div class="hb-layout-desktop__main-after-navbar">
      <div
        class="hb-layout-desktop__content"
        class:hb-layout-desktop__content--single-screen={single_screen}
        part="container"
      >
        {#if single_screen}
          <div class="hb-layout-desktop__page" part="page" id="page">
            <slot name="page">page</slot>
          </div>
          {#if cookielaw === "yes" || cookielaw === "true" || cookielawallowdecline === "yes" || cookielawallowdecline === "no" || cookielawlanguage?.length || cookielawuri4more?.length}
            <hb-cookie-law-banner
              language={cookielawlanguage || i18nlang}
              allowdecline={cookielawallowdecline}
              {cookielawuri4more}
            ></hb-cookie-law-banner>
          {/if}
          <hb-footer
            {policies}
            type={footer.type === "auto" ? "small" : footer.type}
            disable_expanding_small={footer.disable_expanding_small
              ? "yes"
              : "no"}
            part="footer"
            socials={socials ? JSON.stringify(socials) : ""}
            contacts={contacts ? JSON.stringify(contacts) : ""}
            style="display:block;"
            company={company ? JSON.stringify(company) : ""}
            columns={columns || ""}
            onfooterClick={(el: { detail: FooterEvents["footerClick"] }) =>
              dispatch("footerClick", el.detail)}
          ></hb-footer>
        {:else}
          <div
            class="hb-layout-desktop__page hb-layout-desktop__page--footer-inside"
            part="page"
            id="page"
          >
            <div class="hb-layout-desktop__page-stretch">
              <div class="hb-layout-desktop__page-slot">
                <slot name="page">page</slot>
              </div>
              {#if cookielaw === "yes" || cookielaw === "true" || cookielawallowdecline === "yes" || cookielawallowdecline === "no" || cookielawlanguage?.length || cookielawuri4more?.length}
                <hb-cookie-law-banner
                  language={cookielawlanguage || i18nlang}
                  allowdecline={cookielawallowdecline}
                  {cookielawuri4more}
                ></hb-cookie-law-banner>
              {/if}
              <hb-footer
                {policies}
                type={footer.type === "auto" ? "regular" : footer.type}
                disable_expanding_small={footer.disable_expanding_small
                  ? "yes"
                  : "no"}
                part="footer"
                socials={socials ? JSON.stringify(socials) : ""}
                contacts={contacts ? JSON.stringify(contacts) : ""}
                style="display:block;"
                company={company ? JSON.stringify(company) : ""}
                columns={columns || ""}
                onfooterClick={(el: { detail: FooterEvents["footerClick"] }) =>
                  dispatch("footerClick", el.detail)}
              ></hb-footer>
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
